import { createTelemetryObject, createTelemetry } from '@shared/core/analytics';

const category = 'admin';
const pagePrefix = 'WebsiteEditor';
const action = 'ButtonInteracted';

const actionProps = {
  action,
  category,
  pagePrefix,
};

interface ThingsToDoClickedArgs {
  title: string;
  url: string;
  category: string;
  personalNote: string;
  image?: string;
}

const telemObject = createTelemetryObject({
  actions: {
    saveDefaultThingsToDoClicked: (page: string) => ({
      ...actionProps,
      page,
      action,
      label: 'Save DefaultThingsToDo',
      extraInfo: {
        itemType: 'DefaultThingsToDo',
      },
    }),
    saveThingsToDoClicked: (page: string, args: ThingsToDoClickedArgs) => ({
      ...actionProps,
      page,
      action,
      label: 'Save ThingsToDo',
      extraInfo: {
        itemType: 'ThingsToDo',
        ...args,
      },
    }),
    updateThingsToDoClicked: (page: string, args: ThingsToDoClickedArgs) => ({
      ...actionProps,
      page,
      action,
      label: 'Edit ThingsToDo',
      extraInfo: {
        itemType: 'ThingsToDo',
        ...args,
      },
    }),
    deleteThingsToDoClicked: (page: string, args: ThingsToDoClickedArgs) => ({
      ...actionProps,
      page,
      action,
      label: 'Delete ThingsToDo',
      extraInfo: {
        itemType: 'ThingsToDO',
        ...args,
      },
    }),
    goToAddComponentClicked: (page: string, componentType: 'DefaultThingsToDo' | 'ThingsToDo') => ({
      ...actionProps,
      page,
      action,
      label: 'Go to Add ThingsToDo',
      extraInfo: {
        componentType,
      },
    }),
  },
});

const { TelemetryProvider: WebsiteEditorThingsToDoTelemetryProvider, useTelemetry: useWebsiteEditorThingsToDoTelemetry } = createTelemetry(telemObject);

export { WebsiteEditorThingsToDoTelemetryProvider, useWebsiteEditorThingsToDoTelemetry };
